import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("fuel/index"),
  
  store: (userData) => clientAuth.post('fuel/store', { json: userData }),
  

  show:(id)=>clientAuth.get('fuel/show/'+id),

  update:(id,userData)=>clientAuth.post('fuel/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`fuel/destroy/${id}`),
};